<template>
    <v-navigation-drawer
        :model-value="sidebarMenu"
        floating
        width="248"
        rail-width="72"
        class="gst-navigation-drawer"
        :permanent="sidebarMenu"
        :rail="toggleMini"
        @click="toggleMini === true">
        <div class="gst-navigation-drawer-wrapper">
            <div class="u-text-center u-width-100">
                <Logo
                    :is-minimized="toggleMini"
                    class="gst-logo"
                    :class="{
                        'gst-logo--minimized': toggleMini,
                    }" />
                <IconSidebarArrow
                    class="arrow-toggle-mini bg-secondary"
                    :class="{
                        'arrow-toggle-mini--minimized': toggleMini,
                    }"
                    @click.stop="toggleMini = !toggleMini" />
                <user-avatar
                    :is-minimized="toggleMini"
                    :user-details="user"
                    :user-partners="userPartners" />
            </div>
            <v-divider class="mt-6 mb-4 u-width-100" />
            <NavigationDrawerMenu
                class="u-width-100"
                :is-minimized="toggleMini"
                :user-access-controls-config="userAccessControlsConfig"
                @menu-item-clicked="onClickMenuItemMaximizeNavigationDrawer" />
        </div>
        <UserLogoutButton
            class="u-width-100 gst-logout-button"
            :is-minimized="toggleMini" />
    </v-navigation-drawer>
</template>

<script>
import { Logo } from '@components/logo';
import { UserAvatar, UserLogoutButton } from '@components/user';
import { mapGetters } from 'vuex';
import { IconSidebarArrow } from '@assets';
import NavigationDrawerMenu from './_components/NavigationDrawerMenu.vue';

export default {
    name: 'NavigationDrawer',
    i18nOptions: {
        namespaces: '_common',
        keyPrefix: '',
    },
    components: {
        IconSidebarArrow,
        Logo,
        UserAvatar,
        NavigationDrawerMenu,
        UserLogoutButton,
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        sidebarMenu: true,
        toggleMini: false,
    }),
    computed: {
        ...mapGetters({
            user: 'oidcStore/oidcUser',
            userAccessControlsConfig: 'user/accessControlsConfig',
            userPartners: 'user/partners/list',
        }),
    },
    methods: {
        onClickMenuItemMaximizeNavigationDrawer() {
            this.toggleMini = false;
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-navigation-drawer {
    overflow: visible !important;
    background-color: theme-color('white');
    padding: theme-spacing(4) theme-spacing(2) 0;
    box-shadow:
        0px 10px 20px rgba(theme-color-hex('quaternary'), 0.15),
        0px 3px 6px rgba(theme-color-hex('quaternary'), 0.1);
    display: flex;
    flex-direction: column;
    position: fixed;

    .gst-navigation-drawer-wrapper {
        margin-bottom: 120px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .v-navigation-drawer__content {
        position: relative;
        overflow: visible;
        display: flex;
        flex-direction: column;
    }

    .arrow-toggle-mini {
        position: absolute;
        right: -20px;
        border-radius: 50%;
        transform: rotate(-180deg);
        top: 30px;
        cursor: pointer;
        z-index: $z-index-navigation-arrow;
    }

    .arrow-toggle-mini--minimized {
        transform: rotate(0);
    }

    .gst-logo {
        max-width: 124px;
        display: block;
        margin: theme-spacing(0) auto;
        transition: all 0.2s ease;
    }

    .gst-logo--minimized {
        max-width: 32px;
        margin: theme-spacing(0) auto;

        svg {
            max-width: 32px;
        }
    }
}

@media print {
    .gst-navigation-drawer {
        display: none !important;
    }
}
</style>
